<template>
	<div>
		<!-- banner宣传-->
		<section class="main-slider">
			<div class="swiper-container thm-swiper__slider" data-swiper-options='{"slidesPerView": 1, "loop": true,
                      "effect": "fade",
                      "pagination": {
                      "el": "#main-slider-pagination",
                      "type": "bullets",
                      "clickable": true
                      },
                      "navigation": {
                      "nextEl": "#main-slider__swiper-button-next",
                      "prevEl": "#main-slider__swiper-button-prev"
                      },
                      "autoplay": {
                      "delay": 7000
                      }}'>
				<div class="swiper-wrapper">

					<div class="swiper-slide">
						<div class="image-layer "
							style="background-image: url(static/picture/home/banner/main-slider-1-1.jpg);">
						</div>
						<!-- /.image-layer -->
						<div class="main-slider__shape-1">
							<img src="static/picture/home/main-slider-shape-1.png" alt="">
						</div>
						<div class="main-slider__shape-2">
							<img src="static/picture/home/main-slider-shape-2.png" alt="">
						</div>
						<div class="main-slider__shape-3">
							<img src="static/picture/home/main-slider-shape-3.png" alt="">
						</div>
						<div class="container">
							<div class="row">
								<div class="col-xl-12">
									<div class="main-slider__content">
										<!-- 智能焊接云系统 iCloudWeld -->
										<p><span>{{ $t('home.banner_cloud_title') }} </span>{{ $t('home.banner_cloud_subtitle') }}</p>
										<!-- 助力焊接企业数字化转型，打造焊接新模式 -->
										<h2>{{ $t('home.banner_cloud_desc') }}</h2>
										<div class="main-slider__btn-video-box">
											<div class="main-slider__btn-box">
												<a @click="handleRouter('mbCloud','weldCloud')"
													class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
											</div>
											<div class="main-slider__video-link">
												<!-- href="javascript:;" class="video-popup" -->
												<!-- <a @click="handleVideo('static/video/home1.mp4')">
													<div class="main-slider__video-icon">
														<span class="fa fa-play"></span>
														<i class="ripple"></i>
													</div>
												</a> -->
												<!-- <h3 class="main-slider__video-text" style="display: none;">Watch
													<br> how it works
												</h3> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="swiper-slide">
						<!-- ../assets/images/backgrounds/  -->
						<!-- style="background-image: url('static/images/main-slider-1-2.jpg'); -->
						<div class="image-layer"
							style="background-image: url(static/picture/home/banner/main-slider-1-2.jpg);">
						</div>
						<!-- /.image-layer -->
						<div class="main-slider__shape-1">
							<img src="static/picture/home/main-slider-shape-1.png" alt="">
						</div>
						<div class="main-slider__shape-2">
							<img src="static/picture/home/main-slider-shape-2.png" alt="">
						</div>
						<div class="main-slider__shape-3">
							<img src="static/picture/home/main-slider-shape-3.png" alt="">
						</div>
						<div class="container">
							<div class="row">
								<div class="col-xl-12">
									<div class="main-slider__content">
										<!-- 压力容器焊接管理系统 VMES -->
										<p><span>{{ $t('home.banner_vmes_title') }} </span>{{ $t('home.banner_vmes_subtitle') }}</p>
										<!-- 让焊接企业工艺、焊接生产更高效监管协同 -->
										<h2>{{ $t('home.banner_vmes_desc') }}</h2>
										<div class="main-slider__btn-video-box">
											<div class="main-slider__btn-box">
												<a @click="handleRouter('mbSoftware','pressureVessel')"
													class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
											</div>
											<div class="main-slider__video-link">
												<!-- <a href="javascript:;" class="video-popup"> -->
												<!-- <a @click="handleVideo('static/video/home.mp4')">
													<div class="main-slider__video-icon">
														<span class="fa fa-play"></span>
														<i class="ripple"></i>
													</div>
												</a> -->
												<!-- <h3 class="main-slider__video-text">Watch <br> how it works</h3> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="swiper-slide">
						<!-- ../assets/images/backgrounds/ /static/image/ -->
						<!-- style="background-image: url('static/images/main-slider-1-3.jpg');" -->
						<div class="image-layer"
							style="background-image: url(static/picture/home/banner/main-slider-1-3.jpg);">
						</div>
						<!-- /.image-layer -->
						<div class="main-slider__shape-1">
							<img src="static/picture/home/main-slider-shape-1.png" alt="">
						</div>
						<div class="main-slider__shape-2">
							<img src="static/picture/home/main-slider-shape-2.png" alt="">
						</div>
						<div class="main-slider__shape-3">
							<img src="static/picture/home/main-slider-shape-3.png" alt="">
						</div>
						<div class="container">
							<div class="row">
								<div class="col-xl-12">
									<div class="main-slider__content">
										<!-- <p>钢结构行业<span>焊接管理系统 </span></p> -->
										<!-- 钢结构焊接管理系统 SMES -->
										<p><span>{{ $t('home.banner_smes_title') }} </span>{{ $t('home.banner_smes_subtitle') }}</p>
										<!-- 助力焊接企业优化焊接生产资料，降本增效 -->
										<h2>{{ $t('home.banner_smes_desc') }}</h2>
										<div class="main-slider__btn-video-box">
											<div class="main-slider__btn-box">
												<a @click="handleRouter('mbSoftware','steelStructure')"
													class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
											</div>
											<div class="main-slider__video-link">
												<!-- <a href="javascript:;" class="video-popup"> -->
												<!-- <a @click="handleVideo('static/video/home.mp4')">
													<div class="main-slider__video-icon">
														<span class="fa fa-play"></span>
														<i class="ripple"></i>
													</div>
												</a> -->
												<!-- <h3 class="main-slider__video-text">Watch <br> how it works</h3> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

				<!-- If we need navigation buttons -->
				<div class="swiper-pagination" id="main-slider-pagination"></div>

			</div>
		</section>


		<!--系统框架图-->
		<section class="get-to-know" style="padding: 5rem 0 1.5rem;">
			<div class="container">
				<div class="services-three__top ">
					<div class="row" >
						<div class="col-xl-6 col-lg-12">
							<div class="services-three__top-left text-center">
								<div class="section-title text-left">
									<div class="section-title__tagline-box">
										<!-- SYSTEM COMPOSITION -->
										<span class="section-title__tagline">{{ $t('home.system_composition_tagline') }}</span>
										<div class="section-title-shape">
											<img src="static/image/section-title-shape.png" alt="">
										</div>
									</div>
									<!-- 奥太智能焊接云系统组成 -->
									<h2 class="section-title__title">{{ $t('home.system_composition_title') }}</h2>
								</div>
							</div>

                          
						</div>
						<div class="col-xl-6 col-lg-12">
							<div class="services-three__top-right">
								<p class="services-three__top-text">
									<!-- 从企业全业务场景的管理需求入手... -->
									{{ $t('home.system_composition_desc') }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xl-8 col-lg-12">
						<div class="get-to-know__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms"
							style="visibility: visible; animation-duration: 2500ms; animation-delay: 100ms; animation-name: slideInLeft;">
							<!-- <img src="static/picture/home/framework/atkjt02.png" style=" max-width: 100%;" alt=""> -->
							<img :src="getImagePath('atkjt02.png')" style=" max-width: 100%;" alt="">
							<!-- <div class="get-to-know-shape-1">
								<img src="static/picture/home/get-to-know-shape-1.png" alt="">
							</div> -->
						</div>
					</div>
					<div class="col-xl-4 col-lg-12">
						<div class="get-to-know__right">
							<div class="section-title text-left text-center" >
								<div class="section-title__tagline-box">
									<!-- SYSTEM FRAMEWORK -->
									<span class="section-title__tagline">{{ $t('home.system_framework_tagline') }}</span>
									<div class="section-title-shape">
										<img src="static/image/section-title-shape.png" alt="">
									</div>
								</div>
								<!-- 系统架构 -->
								<h2 class="section-title__title" >
									{{ $t('home.system_framework_title') }}</h2>
							</div>
							<ul class="list-unstyled get-to-know__points">
								<li>
									<div class="icon">
										<span class="icon-check" style="color: #237DB9;"></span>
									</div>
									<div class="text">
										<!-- 车间设备： -->
										<span style="color: #237DB9;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_equipment_label') }}
										</span>
										<!-- 支持奥太及其它品牌的焊机入网； -->
										<p>{{ $t('home.arch_equipment_desc') }}</p>
									</div>
								</li>

								<li>
									<div class="icon">
										<span class="icon-check" style="color: #15AA96;"></span>
									</div>
									<div class="text">
										<!-- 网络传输： -->
										<span style="color: #15AA96;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_network_label') }}
										</span>
										<!-- 支持4G/5G移动网络、WIFI、有线等多种方式，满足企业多样的联网需求； -->
										<p>{{ $t('home.arch_network_desc') }}</p>
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-check" style="color: #9BB955;"></span>
									</div>
									<div class="text">
										<!-- 系统应用： -->
										<span style="color: #9BB955;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_app_label') }}
										</span>
										<!-- 实现人、机、料、法、环、测全面管理，构建高效的系统化焊接管理体系； -->
										<p>{{ $t('home.arch_app_desc') }}</p>
									</div>
								</li>

								<li>
									<div class="icon">
										<span class="icon-check" style="color: #F19B14;"></span>
									</div>
									<div class="text">
										<!-- 系统集成： -->
										<span style="color: #F19B14;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_integration_label') }}
										</span>
										<!-- 提供标准信息化接口，与企业ERP、OA、PLM等系统数据共享，避免信息孤岛； -->
										<p>{{ $t('home.arch_integration_desc') }}</p>
									</div>
								</li>
								<li style="display: none;">
									<div class="icon">
										<span class="icon-check" style="color: #F19B14;"></span>
									</div>
									<div class="text">
										<!-- 系统部署： -->
										<span style="color: #F19B14;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_deploy_label') }}
										</span>
										<!-- 支持奥太专有云 、企业私有云、公有云（阿里、华为等）三种系统部署方案； -->
										<p>{{ $t('home.arch_deploy_desc') }}</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!--Project Page One Start-->
		<section class="" style="padding-top: 50px;">
			<div class="container">
				<div class="row">
					<div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
						<div class="project-one__single">
							<div class="project-one__img">
					  			<img src="static/picture/home/gnqf/cj.jpg" alt="">
							</div>
							<div class="project-one__content">
								<div class="pricing__icon">
									<img src="static/picture/home/kk11.png" style="float: left;height: 70px;" alt="">
									<!-- 焊接车间 -->
									<h2 class="pricing__rate">{{ $t('home.scene_workshop_title') }}<span></span></h2>
								</div>
								<!-- 实现焊接车间设备网络化改造 -->
								<h3 class="project-one__title"><a href="#">{{ $t('home.scene_workshop_desc') }}</a></h3>
								<div class="clearfix"></div>
							</div>
						</div>
					</div>
					 <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
					 	<div class="project-one__single">
					 		<div class="project-one__img">
					  			<img src="static/picture/home/gnqf/gc.jpg" alt="">
					 		</div>
					 		<div class="project-one__content">
					 			<div class="pricing__icon">
					 				<img src="static/picture/home/kk14.png" style="float: left;height: 70px;" alt="">
					 				<!-- 焊接工厂 -->
					 				<h2 class="pricing__rate">{{ $t('home.scene_factory_title') }}<span></span></h2>
					 			</div>
					 			<!-- 助力企业实现焊接工厂信息化转型升级 -->
					 			<h3 class="project-one__title"><a href="#">{{ $t('home.scene_factory_desc') }}</a></h3>
					 			<div class="clearfix"></div>
					 		</div>
					 	</div>
					 </div>
					  <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
					  	<div class="project-one__single">
					  		<div class="project-one__img">
					  			<img src="static/picture/home/gnqf/mes.png" alt="">
					  		</div>
					  		<div class="project-one__content">
					  			<div class="pricing__icon">
					  				<img src="static/picture/home/kk15.png" style="float: left;height: 70px;" alt="">
					  				<!-- 焊接MES -->
					  				<h2 class="pricing__rate">{{ $t('home.scene_mes_title') }}<span></span></h2>
					  			</div>
					  			<!-- 为用户提供智能化的综合焊接服务平台 -->
					  			<h3 class="project-one__title"><a href="#">{{ $t('home.scene_mes_desc') }}</a></h3>
					  			<div class="clearfix"></div>
					  		</div>
					  	</div>
					  </div>
				</div>
			</div>
		</section>


		<!--功能区分-->
		<section class="pricing" style="display: none;">
			<div class="container">
				<div class="row">
					<div class="col-xl-4 col-lg-4">
						<!--Pricing Single-->
						<div class="pricing__single">
							<div class="pricing__icon">
								<h2 class="pricing__rate" style="float: left;">{{ $t('home.scene_workshop_title') }}  <!-- 焊接车间 --><span></span></h2>
								<img src="static/picture/home/kk11.png" style="float: right;height: 50px;" alt="">
							</div>
							<div class="clearfix"></div>
							<h3 class="pricing__title">{{ $t('home.scene_workshop_desc') }}</h3>  <!-- 实现焊接车间设备网络化改造 -->
							<div class="pricing__service">
								<p class="pricing__service-title" style="display: none;">{{ $t('home.Main_functions') }}: <!-- 主要功能 --></p>
								<ul class="list-unstyled pricing__service-list">
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>{{ $t('home.feat_workshop_item_1') }} <!-- 实现所有品牌焊接设备联网改造；--></p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>{{ $t('home.feat_workshop_item_2') }} <!-- 实现设备开机时长、焊接时长自动统计；--></p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>{{ $t('home.feat_workshop_item_3') }} <!-- 实时监控焊机运行状态，超范围焊接系统自动报警；--></p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>{{ $t('home.feat_workshop_item_4') }} <!-- 一键导出焊接成本报告、焊接实时曲线及报警记录；--></p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-lg-4">
						<!--Pricing Single-->
						<div class="pricing__single">
							<div class="pricing__icon">
								<h2 class="pricing__rate" style="float: left;">
									<!-- 焊接工厂  -->
									{{ $t('home.feat_factory_title') }} 
								<span></span></h2>
								<img src="static/picture/home/kk14.png" style="float: right;height: 50px;" alt="">
							</div>
							<div class="clearfix"></div>
							<h3 class="pricing__title">
								<!-- 助力企业实现焊接工厂信息化转型升级 -->
									 {{ $t('home.feat_factory_desc') }}</h3>
							<div class="pricing__service">
								<ul class="list-unstyled pricing__service-list">
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
												<p>
													<!-- 实现PQR、WPS的焊接工艺流程化、电子化管理； -->
													 {{ $t('home.feat_factory_item_1') }}
												</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
													<!-- 实现焊接任务工单信息化管理与焊接生产流程的数字化改造； -->
													 {{ $t('home.feat_factory_item_2') }}
												</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
													<!-- 完成焊工信息档案、持证资质、探伤合格率、工艺符合度、焊工业绩等数字化管理； -->
													 {{ $t('home.feat_factory_item_3') }}
												</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
													<!-- 实现焊材库领/退/还信息化管理; -->
													 {{ $t('home.feat_factory_item_4') }}
												</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
												<!-- 一键生成各类统计分析报表； -->
													{{ $t('home.feat_factory_item_5') }}
											</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-lg-4">
						<!--Pricing Single-->
						<div class="pricing__single">
							<div class="pricing__icon">
								<h2 class="pricing__rate" style="float: left;">
									<!-- 焊接MES -->
									{{ $t('home.feat_mes_title') }} 
									<span></span></h2>
								<img src="static/picture/home/kk15.png" style="float: right;height: 50px;" alt="">
							</div>
							<div class="clearfix"></div>
							<h3 class="pricing__title">
								<!-- 为用户提供智能化的综合焊接服务平台 -->
									 {{ $t('home.feat_mes_desc') }}
							</h3>
							<div class="pricing__service">
								<ul class="list-unstyled pricing__service-list">
									
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
												<!-- 完成焊接过程中的焊工、焊机、焊材、工艺、质检一体化管理； -->
													{{ $t('home.feat_mes_item_1') }}
											</p>
										</div>
									</li>
									
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
												<!-- 实时监控焊接过程中各环节的工艺数据，生成焊缝工艺符合度报告； -->
													{{ $t('home.feat_mes_item_2') }}
											</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
												<!-- 焊接生产过程信息化，全程监控，焊接数据可追溯; -->
													{{ $t('home.feat_mes_item_3') }}
											</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
												<!-- 自动生成电子化施焊记录单； -->
													{{ $t('home.feat_mes_item_4') }}
											</p>
										</div>
									</li>
									<li>
										<div class="icon">
											<span class="icon-tick"></span>
										</div>
										<div class="text">
											<p>
												<!-- 与企业PLM、ERP、OA等系统互联互通，实现数据共享； -->
													{{ $t('home.feat_mes_item_5') }}
											</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<!--系统框架-->
		<section class="we-help">
			<div class="container">
				<div class="we-help__inner" style="padding-top: 50px;">
					<div class="section-title text-center">
						<div class="section-title__tagline-box">
							<!-- SYSTEM FRAMEWORK -->
							<span class="section-title__tagline">{{ $t('home.func_framework_tagline') }}</span>
							<div class="section-title-shape">
								<img src="static/image/section-title-shape.png" alt="">
							</div>
						</div>
						<!-- 奥太智能焊接云功能框架 -->
						<h2 class="section-title__title">{{ $t('home.func_framework_title') }}</h2>
					</div>
					<div class="row">
						<!-- <img style="max-width: 100%" src="static/picture/home/framework/atkjt01.png" alt=""> -->
						<img style="max-width: 100%" :src="getImagePath('atkjt01.png')" alt="">
					</div>
				</div>
			</div>
		</section>


		<!--建设目标-->
		<section class="we-help">
			<div class="container">
				<div class="we-help__inner" style="padding-top: 50px;">
					<div class="section-title text-center">
						<div class="section-title__tagline-box">
							<!-- SYSTEM TARGETS -->
							<span class="section-title__tagline">{{ $t('home.targets_tagline') }}</span>
							<div class="section-title-shape">
								<img src="static/image/section-title-shape.png" alt="">
							</div>
						</div>
						<!-- 奥太智能焊接云建设目标 -->
						<h2 class="section-title__title">{{ $t('home.targets_title') }}</h2>
					</div>
					<div class="row">
						<div class="col-xl-12 col-lg-12">
							<div class="we-help__right">
								<div class="we-help__img wow slideInRight" data-wow-delay="100ms"
									data-wow-duration="2500ms">
									<!-- <img src="static/picture/home/framework/ztgh.png" style=" max-width: 100%;" alt=""> -->
									 <img style="max-width: 100%" :src="getImagePath('ztgh.png')" alt="" />
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-lg-4" style="display: none;">
							<div class="we-help__left">
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									<!-- 实现车间所有焊接设备数字化改造... -->
									{{ $t('home.target_item_1') }}</p>
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									<!-- 规范焊接过程中参与的焊工... -->
									{{ $t('home.target_item_2') }}</p>
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									<!-- 实现车间生产计划管理与焊接生产流程... -->
									{{ $t('home.target_item_3') }}
								</p>
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									<!-- 支持与PLM、ERP、OA等系统对接... -->
									{{ $t('home.target_item_4') }}</p>
							</div>
						</div>

					</div>
				</div>
			</div>
		</section>

		<!--核心功能-->
		<section class="services-three service-three--no-pb" style="padding:7rem 0 1.5rem;">
			<div class="container">
				<div class="services-three__top">
					<div class="row">
						

						<div class="col-xl-12 col-lg-12">
							<div class="services-three__top-right text-center">
								<div class="section-title text-left">
									<div class="section-title__tagline-box">
										<!-- SERVICES WE'RE PROVIDING -->
										<span class="section-title__tagline">{{ $t('home.services_tagline') }}</span>
										<div class="section-title-shape">
											<img src="static/image/section-title-shape.png" alt="">
										</div>
									</div>
									<!-- 我们为客户提供的核心功能 -->
									<h2 class="section-title__title">{{ $t('home.services_title') }}</h2>
								</div>
							</div>
						</div>
                        <div class="col-xl-12 col-lg-12">
							<div class="services-three__top-left">
								<p class="services-three__top-text">
									<!-- 面向企业的全业务场景... -->
									{{ $t('home.services_desc') }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="services-three__bottom">
					<div class="row">
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms"
							style="visibility: visible; animation-delay: 100ms; animation-name: fadeInUp;">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg22.jpg" alt=""> -->
									<img src="static/picture/home/function/scgk.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-coding"></span>
									</div>
									<!-- 生产管控<br>MES (使用 v-html 解析 br) -->
									<h3 class="services-three__title"><a v-html="$t('home.service_mes_title')"></a></h3>
									<!-- 管控生产计划与工单... -->
									<p class="services-three__text">{{ $t('home.service_mes_desc') }}</p>
									<!-- <div class="services-three__learn-more">
										<a href="product-development.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg24.jpg" alt=""> -->
									<img src="static/picture/home/function/gygl.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-design-thinking"></span>
									</div>
									<!-- 工艺管理 <br>WPS (使用 v-html 解析 br) -->
									<h3 class="services-three__title"><a v-html="$t('home.service_wps_title')"></a></h3>
									<!-- 高效协同监管焊接工艺准确执行... -->
									<p class="services-three__text">{{ $t('home.service_wps_desc') }}</p>
									<!-- <div class="services-three__learn-more">
										<a href="ui-ux-designing.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg27.jpg" alt=""> -->
									<img src="static/picture/home/function/zlgl.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-technology"></span>
									</div>
									<!-- 质量监管 <br>QMS (使用 v-html 解析 br) -->
									<h3 class="services-three__title"><a v-html="$t('home.service_qms_title')"></a></h3>
									<!-- 建立完整的质量数据追溯链... -->
									<p class="services-three__text">{{ $t('home.service_qms_desc') }}</p>
									<!-- <div class="services-three__learn-more">
										<a href="digital-marketing.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg23.jpg" alt=""> -->
									<img src="static/picture/home/function/sczy.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-content"></span>
									</div>
									<!-- 生产资源 <br>WRS (使用 v-html 解析 br) -->
									<h3 class="services-three__title"><a v-html="$t('home.service_wrs_title')"></a></h3>
									<!-- 合理调度人员、设备、焊材等参与角色... -->
									<p class="services-three__text">{{ $t('home.service_wrs_desc') }}</p>
									<!-- <div class="services-three__learn-more">
										<a href="content-management.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 解决方案 -->
		<section class="delivering-it" style="display: block;">
			<div class="container">
				<div class="delivering-it__top">
					<div class="row">
						<div class="col-xl-12 col-lg-12">
							<div class="delivering-it__top-left">
								<div class="section-title text-center">
									<div class="section-title__tagline-box">
										<!-- INDUSTRY SOLUTIONS -->
										<span class="section-title__tagline">{{ $t('home.solutions_header_tagline') }}
											<!-- Technology platform -->
										</span>
										<div class="section-title-shape">
											<img src="static/image/section-title-shape.png" alt="">
										</div>
									</div>
									<!-- 山东奥太30年深耕焊接行业... -->
									<div class="section-title__title" >
										{{ $t('home.solutions_header_title') }}
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-5 col-lg-5">
							<div class="delivering-it__top-right">
								<p class="delivering-it__top-text" style="font-size: var(--font-size-18);">
									<!-- 聚焦压力容器、长输管道... -->
									{{ $t('home.solutions_header_desc') }}
								</p>
							</div>
						</div>
					</div>
				</div>

			</div>
            <!--  -->
            <div class=" ver ver_box row">
                <div class="col-xl-12 col-lg-12 " style="visibility: visible; animation-name: fadeIn;">
                    <div class="row_act">
                        <div  class="act_img">
                            <div class="row_value_list_item act_img_1 row_value_list_active">
                                <img class="row_value_list_img " src="static/picture/home/mb-solutions/pressure1.jpg" alt="">
                            </div>
                            <div class="row_value_list_item act_img_2">
                                <img class="row_value_list_img  " src="static/picture/home/mb-solutions/make1.jpg" alt="">
                            </div>
                            <div class="row_value_list_item act_img_3">
                                <img class="row_value_list_img " src="static/picture/home/mb-solutions/training1.jpg" alt="">
                            </div>
                            <div class="row_value_list_item act_img_4">
                                <img class="row_value_list_img " src="static/picture/home/mb-solutions/machine1.jpg" alt="">
                            </div>
                            <div class="row_value_list_item act_img_5">
                                <img class="row_value_list_img " src="static/picture/home/mb-solutions/structure1.jpg" alt="">
                            </div>
                            <div class="row_value_list_item act_img_6">
                                <img class="row_value_list_img " src="static/picture/home/mb-solutions/piping1.jpg" alt="">
                            </div>
                        </div>    
                        <div class="act_list">
                            <div class="act_item rvt_nub_action" data-text="1">
                                <div class="act_item_title">
                                    <!-- 压力容器解决方案 -->
                                    {{ $t('home.sol_pressure_title') }}
                                </div>
                                <div class="act_item_content">
                                    <p>
                                        <!-- 压力容器行业解决方案是在... -->
                                        {{ $t('home.sol_pressure_desc') }}
                                    </p>
                                    <a @click="handleRouter('mbSolutionDetail','pressureVessel')"
                                                    class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
                                </div>

                            </div>
                            <div class="act_item " data-text="2">
                                <div class="act_item_title">
                                    <!-- 机械制造解决方案 -->
                                    {{ $t('home.sol_machinery_title') }}
                                </div>
                                <div class="act_item_content">
                                    <p>
                                        <!-- 机械制造行业解决方案是在... -->
                                        {{ $t('home.sol_machinery_desc') }}
                                    </p>
                                    <a @click="handleRouter('mbSolutionDetail','machinery')"
                                                    class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
                                </div>
                            </div>
                            <div class="act_item" data-text="3">
                                <div class="act_item_title">
                                    <!-- 焊培解决方案 -->
                                    {{ $t('home.sol_training_title') }}
                                </div>
                                <div class="act_item_content">
                                    <p>
                                        <!-- 焊培领域智能制造解决方案由... -->
                                        {{ $t('home.sol_training_desc') }}
                                    </p>
                                    <a @click="handleRouter('mbSolutionDetail','weldTraining')"
                                                    class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
                                </div>
                            </div>
                            <div class="act_item" data-text="4">
                                <div class="act_item_title">
                                    <!-- 煤机解决方案 -->
                                    {{ $t('home.sol_coal_title') }}
                                </div>
                                <div class="act_item_content">
                                    <p>
                                        <!-- 煤机领域智能制造解决方案由... -->
                                        {{ $t('home.sol_coal_desc') }}
                                    </p>
                                    <a @click="handleRouter('mbSolutionDetail','coalMachine')"
                                                    class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
                                </div>
                            </div>
                            <div class="act_item" data-text="5">
                                <div class="act_item_title">
                                    <!-- 钢结构解决方案 -->
                                    {{ $t('home.sol_structure_title') }}
                                    
                                </div>
                                <div class="act_item_content">
                                    <p>
                                        <!-- 钢结构焊接智能制造解决方案集成了... -->
                                        {{ $t('home.sol_structure_desc') }}
                                    </p>
                                    <a @click="handleRouter('mbSolutionDetail','steelStructureScheme')"
                                                    class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
                                </div>
                            </div>
                            <div class="act_item" data-text="6">
                                <div class="act_item_title">
                                    <!-- 长输管道解决方案 -->
                                    {{ $t('home.sol_piping_title') }}
                                </div>
                                <div class="act_item_content">
                                    <p>
                                        <!-- 管道行业解决方案是以... -->
                                        {{ $t('home.sol_piping_desc') }}
                                    </p>
                                    <a @click="handleRouter('mbSolutionDetail','piping')"
                                                    class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

		</section>
		<!--合作企业-->
		<section class="trusted-source" style="padding-top: 120px">
			<div class="container">
				<div class="trusted-source__inner wow fadeInUp" data-wow-delay="300ms">
					<div class="trusted-source__left" style="flex: 3;">
						<!-- 智能制造焊接数字化解决方案 <br> 优秀服务提供商 (使用 v-html 解析 br) -->
						<h3 class="trusted-source__content" v-html="$t('home.trusted_source_content')"></h3>
					</div>
					<div class="trusted-source__icon" style="">
						<img src="static/picture/home/trusted-source-icon.png" alt="">
					</div>
					<div class="trusted-source__right" style="flex: 3;">
						<div class="trusted-source__contact-info">
							<!-- 有任何问题请致电我们 -->
							<p>{{ $t('home.trusted_source_contact_title') }}</p>
							<!-- href="tel:400-0531-772" -->
							<a><span> + </span>86-132-0531-8830</a>
						</div>
					</div>
				</div>
				<!-- 合作伙伴 -->
				<div class="we-help__inner" style="padding-top: 50px; padding-bottom: 0;">
					<div class="row" >
						<img src="static/picture/home/custom/khlb.png" alt="" srcset="">
					</div>
				</div>
			</div>

			<div class="container" style="padding-top: 60px;display: none;">
				<div class="row">
					<div class="col-xl-12">
						<ul class="list-unstyled counter-one__list">
							<li class="counter-one__single wow fadeInUp" data-wow-delay="100ms">
								<div class="counter-one__icon">
									<span class="icon-work"></span>
								</div>
								<h3 class="odometer" data-count="30">30</h3>
								<!-- 解决方案 -->
								<p class="counter-one__title">{{ $t('home.stat_solutions') }}</p>
								<div class="counter-one__shadow">SOLUTIONS</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>
							<li class="counter-one__single wow fadeInUp" data-wow-delay="200ms">
								<div class="counter-one__icon">
									<span class="icon-technical-support"></span>
								</div>
								<h3 class="odometer" data-count="12800+">12800+</h3>
								<!-- <span class="counter-one__plus">+</span> -->
								<!-- 入网设备 -->
								<p class="counter-one__title">{{ $t('home.stat_equipment') }}</p>
								<div class="counter-one__shadow">EQUIPMENT</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>
							<li class="counter-one__single wow fadeInUp" data-wow-delay="300ms">
								<div class="counter-one__icon">
									<span class="icon-user"></span>
								</div>
								<h3 class="odometer" data-count="229+">229+</h3>
								<!-- <span class="counter-one__plus">+</span> -->
								<!-- 企业客户 -->
								<p class="counter-one__title">{{ $t('home.stat_clients') }}</p>
								<div class="counter-one__shadow">CLIENT</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>

							<li class="counter-one__single wow fadeInUp" data-wow-delay="300ms">
								<div class="counter-one__icon">
									<span class="icon-like"></span>
								</div>
								<h3 class="odometer" data-count="54">54</h3>
								<!-- 获得荣誉 -->
								<p class="counter-one__title">{{ $t('home.stat_honor') }}</p>
								<div class="counter-one__shadow">HONOR</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<section >
			<div class="container">
				<div  style="padding: 20px 0;">
					<div class="row_div" >

						<!-- <div>
							<a  class="login_tbu" target="_blank" :href="login1" >{{ $t('header.loginV1') }}</a>
						</div>

						<div>
							<a  class="login_tbu"  target="_blank" :href="login2" >
								{{ $t('header.loginV2') }}
							</a>
						</div> -->

						<!-- <div>
							<a  class="login_tbu" @click="handleImg('login1')" >
								{{ $t('header.loginV1') }}
							</a>
						</div> -->

						<div>
							<a  class="login_tbu"  @click="handleImg()" >
								{{ $t('header.login') }}
							</a>
						</div>
					</div>
				</div>
			
			</div>

			
		</section>

		<el-dialog :visible.sync="dialogVisible">
			<video style="width: 900px;" autoplay="autoplay" loop="loop" :src="videoSrc" controls=""></video>
		</el-dialog>
		<el-dialog :visible.sync="imgVisible">
			<div >
				<p style="font-size: var(--font-size-16); line-height: 1.75; color: var(--notech-black);  font-weight: 700; margin-bottom: 30px;">
					
					
						<!-- 微信扫码直达微群控，轻量体验核心功能 -->
						{{ $t('home.mb_login2') }}

				</p>
			</div>
			<img style="width: 200px; height: 200px;"  loop="loop" :src="imgSrc"  />
		</el-dialog>
	</div>
</template>
<script>


	export default {
		name: 'home',
		components: {},
		data() {
			return {
				dialogVisible: false,
				videoSrc: "",
				login1: window._address_env_?.login1 || '',
				login2: window._address_env_?.login2 || '',
				imgSrc: undefined,
				imgVisible: false,
			}
		},
		mounted() {
			
			if ($(".thm-swiper__slider").length) {
				$(".thm-swiper__slider").each(function() {
					let elm = $(this);
					let options = elm.data('swiper-options');
					let thmSwiperSlider = new Swiper(elm, options);
				});
			}

            // 解决方案--切换背景

            $(".act_item").on("click", function(e) {

                // // 切换背景
                $('.row_value_list_active').removeClass('row_value_list_active'); 
                var param = 'act_img_' + $(this).data('text')
                $('.'+param).addClass('row_value_list_active'); 
                // 展示信息
                $('.rvt_nub_action').removeClass('rvt_nub_action');  
                $(this).addClass("rvt_nub_action");

                

            });

		},
		methods: {
			handleVideo(val) {
				this.videoSrc = val
				this.dialogVisible = true
			},
			handleRouter(val, type) {
				if (val && type) {
					this.$router.push({
						path: val,
						query: {
							type: type
						}
					});
				} else {
					// 暂时无法查看！
					this.$message.warning(this.$t('header.tempUnavailable'));
				}

			},

			getImagePath(path) {
				// static/picture/home/framework/atkjt02.png
				var  url = ""
				if(this.$i18n.locale == 'zh_CN') {
					url = 'static/picture/home/framework/' + path
				} else if( this.$i18n.locale == 'en_US') {
					url = 'static/picture/home/framework/en/' + path
				} else if( this.$i18n.locale == 'ru_RU') {
					url = 'static/picture/home/framework/ru/' + path
				} else {
					url = 'static/picture/home/framework/' + path
				}
				return url;
			},
			// 打开
			handleImg() {
				this.imgSrc ="static/picture/common/wqk.jpg"
			
				this.imgVisible = true
			}
		}
	}
</script>

<style scoped>
	@import '../../public/static/css/owl.carousel.min.css';
	@import '../../public/static/css/owl.theme.default.min.css';

	.container {
		max-width: 100% !important;
	}
    /*banner*/
.main-slider .image-layer {
	background-color: transparent;
}

.main-slider h2 {
    font-size: var(--font-size-30) !important;
}

.main-slider p {
    font-size: var(--font-size-24) !important;
	font-weight: bold;
}

.main-slider p>span {
	font-size: var(--font-size-20) !important;
	color: var(--notech-white);
}

.project-one__title {
    font-size: var(--font-size-14);
}
.pricing__rate {
    font-size: var(--font-size-40);
}

.get-to-know__left {
    max-width: 100%;
    position: relative;
    display: block;
}

.get-to-know__right {
    max-width: 100%;
    position: relative;
    display: block;
    margin: 30px 0; 
}

.delivering-it {
    padding: 90px 0;
}
.row_act {
    width: 100%;
    height: 519px;
    visibility: visible;
    animation-name: ysfadeInUp0;
    animation: ysfadeInUp0 .5s ease-in-out 1 both;
    animation-delay: 0.2s;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}
.act_img {
    display: flex;
    width: 100%;
    position: relative;
    display: block;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}

.row_value_list_item {
    display: none;
    transition: opacity 500ms ease 0s;
}

.row_value_list_img{
    background-color: var(--notech-black);
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transform: scale(1);
    transition: transform 7000ms ease, opacity 1500ms ease-in;
    background-blend-mode: luminosity;
    background-color: var(--notech-black);
    z-index: 1;
   
}

.row_value_list_active {
    display: block;
}

.act_list {
    color: #fff;
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
    /* display: flex; */
}

.act_item {
    width: 100%;
    height: auto;
    transition: all 0.36s;
    position: relative;
}

.act_item_title {
    padding: 8px 20px;
    opacity: 1;
    font-size: 16px;
    width: 100%;
    position: static;
    transform: inherit;
    background: rgba(255, 255, 255, 0.3);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.rvt_nub_action .act_item_content {
    display: block;
}
.act_item_content {
    display: none;
    width: 100%;
    height: 225px;
    /* opacity: 1; */
    position: relative;
    top: inherit;
    left: inherit;
    transform: inherit;
   

    padding: 30px 20px;
}

.act_item_content p {
    max-height: 100px;
    overflow: hidden;
    font-size: 14px;
    line-height: 1.85;
    transition: all 10s;
    word-wrap: break-word;
    word-break: normal;
}
.act_item_content .thm-btn  {
    margin-top: 30px;
    font-size: 14px;
    padding: 0 12px;
    line-height: 32px;
}

.g_sect2cen {
    position: static;
}
.g_sect2cen {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
	.get-to-know__left {
		margin-right: 0;
	}

	.get-to-know__points .text {
		font-size: 18px;
	}

	.get-to-know__points li {
		align-items: baseline !important;
	}

.trusted-source__contact-info {
    color: #fff;
}

	.vertical_img {
		width: 48px;
		height: 48px;
	}

	.vertical_img img {
		width: 48px;
		height: 48px;
	}

	.ver_item {
		cursor: pointer;
		margin-bottom: 40px;
		font-size: 24px;
	}

	.we-help__inner {
		border-bottom: 0;
		padding: 80px 0;
	}

	.r_act {
		display: none;
	}

	.r_active {
		display: block;
	}

	::v-deep .el-dialog {
		 width: 95%;
		/* background: transparent; */

	}
	::v-deep .el-dialog__body {
    display: flex;
    align-items: center;
  justify-content: center;
  flex-direction: column;
    width: 100%;
}

	.anli img {
		box-shadow: 8px 8px 5px #ccc;
	}

	/* ::v-deep .el-dialog__headerbtn .el-dialog__close {
		color: var(--notech-white) !important;
	} */

	.obtain:hover {
		color: var(--notech-white);
		background: var(--notech-black);
	}

	.pricing__icon img {
		height: 120px;
	}

	.pricing__single {
		height: 100%;
		margin-bottom: 0;
	}

	.project-one__img {
		background-color: transparent;
	}
	.project-one__content{
		padding: 40px 30px ;
	}


	.login_tbu {
		max-width: 45%;
		background-color: var(--notech-base);
		color: var(--notech-white);
		font-size: var(--font-size-16);
		font-weight: 700;
		padding: 14px 40px 14px;
		-webkit-transition: all 0.5s linear;
		transition: all 0.5s linear;
		overflow: hidden;
	}

	.row_div {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
</style>